import { useEffect } from 'react';
import { KibContainer } from '@chewy/kib-layout-react';

import { CmsUniversal } from '@src/pages/landing/components/cms/cms-universal';
import { CmsComponentData } from '@src/pages/landing/components/cms/cms.types';
import { GetGeneralPageApiResponse, Zone } from '@src/@types/cms';
import '@chewy/kib-layout-styles/dist/styles/kib-container.css';

interface CmsLandingPageProps {
  cmsLandingPageContent: GetGeneralPageApiResponse;
  activate?: VoidFunction;
}

export const CmsLandingPage = ({
  cmsLandingPageContent,
  activate,
}: CmsLandingPageProps) => {
  // If provided, send activation event to analytics for CMS landing page experiment
  useEffect(() => activate?.(), [activate]);

  // Iterate through every zone's components array
  // and render its corresponding widget(s).
  return (
    <KibContainer
      id="hc-pet-insurance-cms__landing"
      data-testid="cms-landing-page-container"
      full
      align="center"
    >
      {cmsLandingPageContent.zones.map((zone: Zone) =>
        zone.components.map((cmsComponent: CmsComponentData) => (
          <CmsUniversal key={cmsComponent.id} data={cmsComponent} />
        )),
      )}
    </KibContainer>
  );
};
